/**
 * Emailed links carry the one-time token in the URL fragment (never sent to servers or Referer).
 * It is moved to sessionStorage and removed from the address bar, so a refresh keeps working
 * without leaving the token in browser history.
 */
export function takeLinkToken(storageKey: string): string | null {
  const match = window.location.hash.match(/token=([A-Za-z0-9_-]+)/);
  if (match) {
    sessionStorage.setItem(storageKey, match[1]);
    window.history.replaceState(null, '', window.location.pathname);
    return match[1];
  }
  return sessionStorage.getItem(storageKey);
}

export function forgetLinkToken(storageKey: string): void {
  sessionStorage.removeItem(storageKey);
}
